import React from 'react'
import { NumericFormat } from 'react-number-format'

import { Asset } from 'types'

import { paveApi } from 'api'
import VirtualOptionsList from 'components/common/VirtualOptionsList/VirtualOptionsList'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSDropdown from 'designSystem/components/PDSDropdown/PDSDropdown'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSText from 'designSystem/components/PDSText/PDSText'
import PDSTextInput from 'designSystem/components/PDSTextInput/PDSTextInput'
import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_WEIGHT } from 'designSystem/foundations/constants/fontWeight'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  handleAdd: (asset: Asset) => void
  scrollDown: Function
  handleCancel?: () => void
}

function AddAssetForm({ handleAdd, scrollDown, handleCancel }: Props) {
  const [symbol, setSymbol] = React.useState<string>('')
  const [shares, setShares] = React.useState<string>('')
  const { data: assets } = paveApi.useGetAssetsQuery()

  const handleClick = () => {
    const asset = assets?.find((asset) => asset.symbol === symbol)
    if (asset)
      handleAdd({
        ...asset,
        symbol,
        shares: parseFloat(shares),
        tradablePercentage: 1,
      })
  }

  return (
    <PDSFlexBox flexDirection="column" gap={SIZE.s8} width="100%">
      <PDSText
        fontSize="sm"
        fontWeight={FONT_WEIGHT.medium}
        color={COLOR.textPrimary}
      >
        Add Another Asset
      </PDSText>
      <PDSFlexBox width="100%">
        {assets ? (
          <PDSDropdown
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
              MenuList: VirtualOptionsList,
            }}
            menuShouldBlockScroll={false}
            onChange={(option: any) => setSymbol(option.value)}
            onMenuOpen={() => {
              scrollDown()
            }}
            options={assets.map(({ symbol, name }) => ({
              value: symbol,
              label: name,
            }))}
            placeholder="Asset name or ticker"
            value={symbol ? { label: symbol, value: symbol } : null}
          />
        ) : (
          <PDSText fontSize="xs">Loading assets...</PDSText>
        )}
      </PDSFlexBox>
      <NumericFormat<any>
        allowNegative={false}
        allowLeadingZeros={false}
        customInput={PDSTextInput}
        decimalScale={4}
        displayType="input"
        maxLength={12}
        onChange={(v) => {
          setShares(v.target.value)
        }}
        placeholder="Number of shares"
        value={shares}
      />

      <PDSFlexBox
        alignItems="flex-start"
        gap={SIZE.s12}
        alignSelf="stretch"
        width="100%"
      >
        <PDSFlexBox width="100%">
          <PDSButton
            size="md-f"
            onClick={handleClick}
            disabled={!symbol || !shares}
            text="Add Asset"
            variant="tertiary"
            iconLeft="plus"
          />
        </PDSFlexBox>
        <PDSFlexBox width="100%">
          {handleCancel && (
            <PDSButton
              size="md-f"
              onClick={handleCancel}
              text="Cancel"
              variant="tertiary"
            />
          )}
        </PDSFlexBox>
      </PDSFlexBox>
    </PDSFlexBox>
  )
}

export default AddAssetForm
